var map = {
	"./A.svg": 1331,
	"./AccessAble-logo.png": 7756,
	"./B.svg": 432,
	"./ExamLocations.svg": 3525,
	"./Graduation.svg": 8362,
	"./OfferHoldersDay.svg": 2909,
	"./PTSans-Bold.ttf": 882,
	"./PTSans-BoldItalic.ttf": 8510,
	"./PTSans-Italic.ttf": 363,
	"./PTSans-Regular.ttf": 3281,
	"./PrayerAndReflectionLG.svg": 8302,
	"./UofG_App_Logo.svg": 9811,
	"./UofG_Life.png": 8712,
	"./af/individual_components.svg": 8082,
	"./af/s_graded.svg": 5187,
	"./af/s_notopen.svg": 7479,
	"./af/s_notsubmitted.svg": 4898,
	"./af/s_overdue.svg": 1032,
	"./af/s_submit.svg": 4712,
	"./af_course.svg": 6601,
	"./af_failure.svg": 252,
	"./af_overdue.svg": 3266,
	"./af_submitted.svg": 6293,
	"./af_success.svg": 9099,
	"./apple-app-store-badge.svg": 4226,
	"./bell.svg": 5853,
	"./br_down.png": 6029,
	"./br_down.svg": 8725,
	"./br_up.png": 1798,
	"./br_up.svg": 3994,
	"./byod.png": 7618,
	"./capacity.svg": 5706,
	"./chevron-down-light.svg": 8391,
	"./circle-tick.svg": 8468,
	"./cleanDeep.svg": 6411,
	"./cleanMaterials.svg": 5997,
	"./clearStar.png": 6913,
	"./club_img.svg": 9654,
	"./clubs/Academic.svg": 5089,
	"./clubs/Arts and Music.svg": 2052,
	"./clubs/Charity and Fundraising.svg": 7685,
	"./clubs/Crafts and Hobbies.svg": 3574,
	"./clubs/Environment and Nature.svg": 3957,
	"./clubs/Faith.svg": 468,
	"./clubs/Fiction and Fantasy.svg": 2761,
	"./clubs/Food and Drink.svg": 1409,
	"./clubs/Health and Wellbeing.svg": 8456,
	"./clubs/Languages and Culture.svg": 8876,
	"./clubs/Media and Broadcasting.svg": 7166,
	"./clubs/Other.svg": 2150,
	"./clubs/Political and Activism.svg": 428,
	"./clubs/Skills and Employability.svg": 1833,
	"./clubs/Sport.svg": 7182,
	"./clubs/Technology and Gaming.svg": 7408,
	"./clubs/defaultsport.png": 4857,
	"./deadlineIcon.png": 543,
	"./defibrillator.svg": 4165,
	"./defibrillatorLG.svg": 7998,
	"./desktop.png": 2438,
	"./destination.png": 370,
	"./error_24px_rounded.png": 5709,
	"./error_blue.svg": 6539,
	"./error_white.svg": 2286,
	"./event_bg.svg": 4060,
	"./event_img.svg": 1254,
	"./events-hmpg.svg": 5232,
	"./facemask.svg": 4845,
	"./far-chevron-down.svg": 952,
	"./far-chevron-left-disabled.svg": 8504,
	"./far-chevron-left-white.svg": 6871,
	"./far-chevron-left.svg": 8727,
	"./far-chevron-right-disabled.svg": 6315,
	"./far-chevron-right-white.svg": 5790,
	"./far-chevron-right.svg": 2418,
	"./find-a-building-hmpg.svg": 1969,
	"./google-play-badge.png": 4624,
	"./gradeIcon.svg": 4672,
	"./greenTick.svg": 9300,
	"./group.png": 1419,
	"./group.svg": 3919,
	"./hw_counselling.svg": 665,
	"./hw_counselling_bkgnd.jpg": 5352,
	"./hw_nightline.svg": 8320,
	"./hw_nightline_bkgnd.jpg": 6453,
	"./hw_reporting.svg": 6910,
	"./hw_togetherall.svg": 7415,
	"./hw_togetherall_bkgnd.jpg": 1002,
	"./hw_wellbeing.svg": 3257,
	"./hw_wellbeing_lg_bkgnd.svg": 892,
	"./hw_wellbeing_sm_bkgnd.svg": 8607,
	"./index/deadline.svg": 8410,
	"./index/deadlines_grades.svg": 1955,
	"./index/expandChev.svg": 1921,
	"./index/hp_ass_feed.svg": 5690,
	"./index/hp_moodle.svg": 1076,
	"./index/hp_timetable.svg": 8085,
	"./index/link_booking.svg": 3433,
	"./index/location_details.svg": 1179,
	"./index/location_details_solid.svg": 3783,
	"./index/main_logo.png": 848,
	"./index/moodle.svg": 2085,
	"./index/on_campus.svg": 4234,
	"./index/online_live.svg": 6985,
	"./index/recorded.svg": 7913,
	"./index/room_booking.svg": 5836,
	"./index/see_moodle.svg": 2933,
	"./individual.png": 2413,
	"./keydates/Academic.svg": 5012,
	"./keydates/Elections.svg": 9691,
	"./keydates/Enrolment.svg": 2415,
	"./keydates/Examination.svg": 4480,
	"./keydates/Graduation.svg": 2257,
	"./keydates/Revision.svg": 4018,
	"./keydates/Teaching.svg": 2772,
	"./keydates/Vacation.svg": 8596,
	"./library/available.png": 8719,
	"./library/overdue.png": 1494,
	"./location.png": 109,
	"./logo-bg.png": 2493,
	"./logo.gif": 2686,
	"./logo.png": 3153,
	"./logo2.png": 4343,
	"./main_logo_uofglife.png": 5441,
	"./maintenance.svg": 2127,
	"./map-hmpg.svg": 5003,
	"./nearme/accessibleparking.png": 9787,
	"./nearme/accessibletoilet.png": 6508,
	"./nearme/atm.png": 4181,
	"./nearme/attraction.png": 4582,
	"./nearme/babychanging.png": 8200,
	"./nearme/bikerack.png": 6903,
	"./nearme/default.png": 1666,
	"./nearme/defibrillator.png": 9722,
	"./nearme/examlocations.png": 8698,
	"./nearme/foodoutlet.png": 2002,
	"./nearme/graduation.png": 3429,
	"./nearme/offerholdersday.png": 34,
	"./nearme/periodproduct.png": 8801,
	"./nearme/prayerandreflection.png": 8442,
	"./nearme/repairs.png": 1811,
	"./nearme/retailoutlet.png": 5151,
	"./nearme/shower.png": 2795,
	"./nearme/studentsupportofficer.png": 3065,
	"./nearme/toilet.png": 1846,
	"./nearme/waterfountain.png": 9240,
	"./no_internet.svg": 2585,
	"./noti-bell.svg": 3504,
	"./notif_bg.svg": 1038,
	"./online.png": 4289,
	"./origin.png": 2338,
	"./period-productLG.svg": 3208,
	"./rag-amber.svg": 6446,
	"./rag-green.svg": 8430,
	"./rag-red.svg": 4254,
	"./redCross.svg": 2693,
	"./retail-outletLG.svg": 6352,
	"./room.png": 273,
	"./schedule_24px.jpg": 9174,
	"./schedule_24px.png": 9714,
	"./social/facebook.svg": 9410,
	"./social/instagram.svg": 5046,
	"./social/twitter.svg": 8927,
	"./solid-burger-fries-slash.svg": 2133,
	"./spaceindicator.png": 4501,
	"./spacelevels.png": 3441,
	"./studentsupportofficers.svg": 4737,
	"./style.scss": 2618,
	"./support-and-wellbeing-hmpg.svg": 1088,
	"./test.png": 3408,
	"./voteEnd.png": 1329,
	"./voteEnd.svg": 5985,
	"./voteStart.png": 2882,
	"./voteStart.svg": 8866,
	"./voting-icon.svg": 607,
	"./wellbeing-support-hmpg.svg": 7928,
	"./yellowStar.png": 2472
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;